import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";
import { useAuth } from "contexts/AuthContext";
import { getAllowedRoutes } from "utils/routeAccess";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const { user } = useAuth();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("");
  const allowedRoutes = React.useMemo(
    () => getAllowedRoutes(routes, "app", user),
    [user]
  );

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  // Match on the pathname rather than the full href: with flat URLs a substring
  // search over the whole address could match a query string or the host.
  const activeRoute = React.useMemo(
    () =>
      allowedRoutes.find((route) => location.pathname === `/${route.path}`) ??
      allowedRoutes[0],
    [allowedRoutes, location.pathname]
  );

  React.useEffect(() => {
    setCurrentRoute(activeRoute?.name ?? "");
  }, [activeRoute]);

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[270px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"UI Tailwind React"}
              brandText={currentRoute}
              secondary={activeRoute?.secondary ?? false}
              {...rest}
            />
            
            {/* main class for rendering content */}
            <div className="pt-5 mx-auto mb-auto h-full min-h-[80vh] p-2 md:pr-2"> 
            
              <Outlet />
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
